import { PaymentMethodType } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { useCreditCardDetails } from '@/components/modules/_shared/hooks/useCreditCard';
import { BorrowerDocumentation } from '@/components/modules/CreditCard/Detail/Documentation/components/BorrowerDocumentation';
import { DocumentationMode } from '@/components/modules/Documentation/types/DocumentationMode';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { APP_ROLES } from '@/config/config';
import { PendingDataType } from '@/config/types';
import { useUser } from '@/hooks/useUser';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const CreditCardDocumentation = () => {
  const { creditCardId } = useParams();
  const { userEntity } = useUser();

  const { documentation, onboardingDetails } = useCreditCardDetails({ creditCardId: creditCardId! });

  if (!documentation || !onboardingDetails || !documentation.requiredFiles?.length) {
    return <PendingDataWarning type={PendingDataType.DEFAULT} />;
  }

  const hasRoleIbcCallCenter = userEntity?.hasRole([APP_ROLES.IBC_CALL_CENTER]);

  const mode = hasRoleIbcCallCenter ? DocumentationMode.VIEW_ONLY : DocumentationMode.DOWNLOAD_ONLY;

  return (
    <BorrowerDocumentation
      mode={mode}
      paymentMethodType={PaymentMethodType.CREDIT_CARD}
      documentation={documentation}
      onboardingDetails={onboardingDetails}
    />
  );
};

export const CreditCardDocumentationModule = withPermissionsModule(CreditCardDocumentation);
